module.exports = __webpack_public_path__ + "img/serve15.5e0bfcc6.png";